import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import AssessmentResult from './AssessmentResult';
import ListGroup from 'react-bootstrap/ListGroup';
import Form from 'react-bootstrap/Form';
import { isNullOrEmpty } from '../../helpers/LanguageHelpers';
import authService from '../../services/AuthService';
import { alertPopup, apiErrorPopup, confirmPopup } from '../../helpers/MessagePopup';

class AssessmentResults extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    assessmentDeleteHandler = (aId, markOnly) => {
        confirmPopup('warning', "Archiving an assessment removes your ability to access the assessment's responses and analysis!  Are you sure you want to archive this assessment?",
            null, "Yes", "No", this.props.assessmentDeleteHandler.bind(this,aId, markOnly), null); 
    }

    render() {

        let childPatient = null;

        if (authService.isCaregiverOrRater) {
            childPatient = "child";
        }
        else if (authService.isParentAccount) {
            childPatient = "child";
        }
        else {
            childPatient = "patient";
        }
        
        let providerInfoClass = "home_ProviderInfo";
        if (this.props.isCaregiver == true || this.props.providerId == null) {
            providerInfoClass += " home_ProviderInfoNoDisplay";
        }

        // Map the assessments to a ListGroupItem
        const assessments = this.props.personAssessments.map((assessment, index) => {
            let isAdmin = assessment.authenticatedUserIsAdmin;
            return <AssessmentResult
                key={assessment.id}
                assessmentId={assessment.id}
                assessmentSelectionHandler={this.props.assessmentSelectionHandler}
                assessmentDeleteHandler={this.assessmentDeleteHandler}
                assessmentCopyHandler={this.props.assessmentCopyHandler}
                canCopyAssessment={this.props.canCopyAssessment}
                isAdmin={isAdmin}
                createDate={assessment.createDate}
                configurationItems={assessment.configurationItems}
                patientFn={this.props.firstName}
                patientLn={this.props.lastName}
                patientBd={this.props.birthDate}
                providerId={this.props.providerId}
            />
        });

        return (
            <Fragment>
                <div onClick={() => { return false; }} className="home_selectedPersonDiv">
                    <ListGroup>
                        <Form className='home_resultsForm'>
                            {assessments}
                        </Form>
                    </ListGroup>
                </div>
                
            </Fragment>
        )
    }
}

export default withRouter(AssessmentResults);


// WEBPACK FOOTER //
// ./src/components/Home/AssessmentResults.js